/* eslint-disable prettier/prettier */
import React from 'react';
import PropTypes from 'prop-types';
import { 
  FormControl, 
  FormHelperText, 
  makeStyles, 
  TextField,
  Chip,
  Paper,
  MenuItem,
  Popper,
  ClickAwayListener,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { appColors } from 'styles/colors';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    '& label': {
      color: appColors.field.normal,
    },
    '& label.Mui-focused': {
      color: appColors.field.primary,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: appColors.field.primary,
    },
    '& .MuiOutlinedInput-input': {
      paddingTop: 19.5,
      paddingBottom: 19.5,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: appColors.field.normal,
      },
      '&:hover fieldset': {
        borderColor: appColors.field.hover,
      },
      '&.Mui-focused fieldset': {
        borderColor: appColors.field.primary,
      },
    },
  },
  formControl: {
    width: '100%',
    marginTop: 16,
    marginBottom: 8,
    minWidth: 120,
  },
}));

export default function SelectMultipleV4({
  label,
  input,
  meta: { touched, error },
  options = [],
  disabled,
  helperText,
}) {
  const classes = useStyles();

  const currentValue = input?.value && Array.isArray(input.value) ? input.value : [];


  const handleChange = (event, value) => {
    if (input?.onChange) {
      input.onChange(value);
    }
  };

  return (
    <div className={classes.root}>
      <FormControl
        aria-label="Tooltip do Formulário"
        variant="outlined"
        color="primary"
        className={classes.formControl}
      >
        <Autocomplete
          id={`select-multiple-${label}`}
          multiple
          filterSelectedOptions
          options={options}
          value={currentValue}
          getOptionLabel={(option) => option?.title || option?.name || ''}
          getOptionSelected={(option, value) => {
            // Comparação que converte para string para evitar problemas de tipo
            const optionId = String(option?.id);
            const valueId = String(value?.id);
            return optionId === valueId;
          }}
          onChange={handleChange}
          disableClearable
          disabled={disabled}
          renderInput={(params) => (
            <TextField 
              {...params} 
              variant="outlined" 
              label={label}
              error={touched && !!error}
            />
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                key={option?.id || index}
                label={option?.title || option?.name || ''}
                {...getTagProps({ index })}
                size="small"
              />
            ))
          }
        />
        {touched && error ? (
          <FormHelperText style={{ color: '#FF5A52' }}>{error}</FormHelperText>
        ) : (
          <FormHelperText>{helperText || 'Você pode selecionar mais de uma opção'}</FormHelperText>
        )}
      </FormControl>
    </div>
  );
}

SelectMultipleV4.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.array,
  }),
  label: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
    })
  ),
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
};

SelectMultipleV4.defaultProps = {
  meta: { touched: false, error: null },
  options: [],
};
